import { GallerySchema } from '@babyn-yar/schema';
import { API_URL } from '../context';
import { fetcher } from '../fetcher';
import * as v from 'valibot';
export var GalleryAPI;
(function (GalleryAPI) {
    const BASE_URL = API_URL + '/gallery';
    async function list() {
        const response = await fetcher(BASE_URL);
        return v.parse(GallerySchema.ListResponse, response);
    }
    GalleryAPI.list = list;
    async function add(image) {
        const response = await fetcher(BASE_URL, {
            method: 'POST',
            body: JSON.stringify(image)
        });
        return v.parse(GallerySchema.DetailRespone, response);
    }
    GalleryAPI.add = add;
    async function remove(id) {
        return fetcher(`${BASE_URL}/${id}`, { method: 'DELETE' });
    }
    GalleryAPI.remove = remove;
})(GalleryAPI || (GalleryAPI = {}));
